const KEY = "nodeImpersonation";

// Admin "view Node as this user" preview. Stored in sessionStorage (not the
// redux-persist localStorage root) so a preview stays confined to the tab it
// was started in and dies with it.
//
// The value is read once per page load: starting and exiting a preview both
// trigger a full navigation, so it never changes mid-session and selectors
// can treat it as a constant instead of re-reading storage on every call.
function read() {
  try {
    const parsed = JSON.parse(sessionStorage.getItem(KEY));
    return parsed?.user?.id ? parsed : null;
  } catch {
    return null;
  }
}

const current = read();

export function getImpersonation() {
  return current;
}

export function startImpersonation(impersonation) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(impersonation));
  } catch {
    // Storage disabled — the preview simply won't start.
  }
}

export function stopImpersonation() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {}
}
